module.exports = __webpack_public_path__ + "img/Dundee-Rep-Logo.7ca82063.png";